import { FONT_BRIGHTNESS_MAPPING } from './constants';
import { fontSizes } from './fontSizes';
export const input = ({ colors, themeVariables, }) => {
    const fontBrightness = themeVariables.inputFontBrightness;
    const asphalt = colors[FONT_BRIGHTNESS_MAPPING.asphalt[fontBrightness]];
    const black = colors[FONT_BRIGHTNESS_MAPPING.black[fontBrightness]];
    const dove = colors[FONT_BRIGHTNESS_MAPPING.dove[fontBrightness]];
    const defaultInput = {
        bg: colors[themeVariables.inputBackgroundColor] ||
            themeVariables.inputBackgroundColor,
        borderColor: colors[themeVariables.inputOutlineColor] ||
            themeVariables.inputOutlineColor,
        borderRadius: 5,
        color: asphalt,
        disabled: {
            opacity: 0.6,
        },
        error: {
            borderColor: colors.fire,
            color: colors.fire,
        },
        focus: {
            borderColor: colors.primary,
        },
        fontSize: fontSizes[2],
        height: 40,
        iconColor: black,
        iconSize: 24,
        placeholder: dove,
    };
    return Object.assign(Object.assign({}, defaultInput), { normal: defaultInput, small: Object.assign(Object.assign({}, defaultInput), { height: 32, iconSize: 20 }) });
};
//# sourceMappingURL=input.js.map